module.exports = __webpack_public_path__ + "static/media/logo-greenthumb.0df80ae3.svg";